export default class Step {
    constructor(stepCount, name) {
        this.stepCount = stepCount;
        this.name = name;
    }
}
